import React, { useState } from 'react';
import { Box, Link, Modal, IconButton, Backdrop } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface GifModalProps {
    gifUrl: any;
    linkText: any;
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 1,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '90vw',
    height: '90vh',
    overflow: 'hidden',
  };

const GifWithModal: React.FC<GifModalProps> = ({ gifUrl, linkText }) => {
    const [open, setOpen] = useState<boolean>(false);

    const handleOpen = (): void => setOpen(true);
    const handleClose = (): void => setOpen(false);

    return (
        <>
            <Link component="button" onClick={handleOpen} sx={{ paddingBottom: 3 }}>
                <img
                    src={gifUrl}
                    alt="GIF content"
                    style={{
                        display: 'block',
                        maxWidth: '100%',
                        height: 'auto',
                    }}
                />
            </Link>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="gif-modal"
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{ 
                    backdrop: { 
                        timeout: 500,
                        onClick: handleClose 
                    } 
                }}
            >
                <Box sx={style}>
                    <img
                        src={gifUrl}
                        alt="GIF content"
                        style={{
                            display: 'block',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            width: 'auto',
                            height: 'auto',
                            objectFit: 'contain',
                        }}
                    />
                </Box>
            </Modal>
        </>
    );
};

export default GifWithModal;
